export default "__VITE_ASSET__BfQM2kEH__"